<template>
  <div>
    <el-card>
      <div class="ibtn-box">
        <div
          id="dailyCharts"
          style="height: 282px; margin-top: 20px; margin-bottom: 40px"
        ></div>
      </div>
      <div class="ibtn-box">
        <div id="voltagesCharts" style="height: 282px; margin-top: 20px"></div>
      </div>
    </el-card>
    <el-card>
      <div>
        <div class="histroy_list">
          <p>历史电芯数据</p>
          <p>
            <el-date-picker
              size="mini"
              v-model="firstDay"
              type="datetime"
              format="yyyy-MM-dd"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-button type="primary" size="mini" @click="openList()"
              >获取本地电芯数据</el-button
            >
          </p>
        </div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="listData"
          stripe
          class="table-list"
          @selection-change="handleSelectionChange"
        >
          <el-table-column width="15"></el-table-column>
          <el-table-column label="日志时间" min-width="150">
            <template slot-scope="scope">
              <h4>
                {{ scope.row.gmtCreate }}
              </h4>
            </template>
          </el-table-column>
          <el-table-column
            prop="modifiedBy"
            label="操作人"
            min-width="100"
          ></el-table-column>
          <el-table-column prop="fileSize" label="大小"></el-table-column>
          <el-table-column prop="gmtModified" label="时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <a @click="downloadFile(scope.row)">
                <el-button size="mini" icon="el-icon-download">
                  下载
                </el-button>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager-box" style="margin: 20px 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
      title="获取本地电芯数据"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-select v-model="fileType" placeholder="请选择文件" size="mini">
        <el-option
          v-for="item in fileList"
          :key="item.filePath"
          :label="item.fileName"
          :value="item.filePath"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="applyUp()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as echarts from "echarts"; //eslint-disable-line no-unused-vars
// import "echarts/map/js/china"; // 引入中国地图数据
import { AxiosAjax } from "../../js/axios.config";
import JSZip from "jszip";
import Papa from "papaparse";
import axios from "axios";
export default {
  data() {
    return {
      tempTime: "",
      fileList: [],
      fileType: "",
      firstDay: "",
      dialogVisible: false,
      loading: false,
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      echartList: [],
      dailyData: [], //日统计
      id: "",
      companyId: "",
      colorList: ["#267cb7", "#00aa00", "#0055ff", "#82c572"],
      initTimes: "",
      csvData: [],
    };
  },
  mounted() {
    const _this = this;
    _this.id = _this.$route.query.id || "";
    _this.companyId = _this.$route.query.companyId || "";
    const monthStr =
      new Date().getMonth() + 1 > 9
        ? new Date().getMonth() + 1
        : "0" + (new Date().getMonth() + 1);
    const dayStr =
      new Date().getDate() > 9
        ? new Date().getDate()
        : "0" + new Date().getDate();
    _this.firstDay = new Date().getFullYear() + "-" + monthStr + "-" + dayStr;
    _this.init();
    _this.initTimes = setInterval(function () {
      _this.init();
    }, 180000);
    //电压电流
    _this.tempTime = setInterval(function () {
      _this.voltageTemp();
    }, 8000);
    _this.initData();
  },
  beforeDestroy() {
    const _that = this;
    clearInterval(_that.tempTime);
    clearInterval(_that.initTimes);
  },
  methods: {
    init() {
      const _this = this;
      const params = {
        cabinetCode: _this.$route.query.cabinetCodes,
        minute: 3,
        module: 4,
      };
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/setPublish",
        data: params,
        success: function (res) {
          _this.voltageTemp();
        },
      });
    },
    voltageTemp() {
      const _this = this;
      AxiosAjax({
        url: "/cabinet/monomers/" + _this.id,
        success: function (res) {
          _this.dailyData = res.data.data;
          _this.initChart();
        },
      });
    },
    async downloadFile(item) {
      try {
        if (!item.absolutePath) {
          return;
        }
        const response = await fetch(item.absolutePath, {
          method: "GET",
          // fetch 默认不会将响应解析为 JSON，所以不需要设置responseType
        });
        const blob = await response.blob();
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        //   link.setAttribute("download", item.fileName);
        link.download = item.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
    applyUp() {
      const _this = this;
      const params = {
        cabinetCode: this.$route.query.cabinetCodes,
        dateTime: this.firstDay,
        filePath: this.fileType,
        typeName: "",
      };
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/uploadLogFile",
        data: params,
        success: function (res) {
          _this.dialogVisible = false;
          _this.initData();
        },
      });
    },
    openList() {
      const _this = this;
      const params = {
        cabinetCode: this.$route.query.cabinetCodes,
        dateTime: this.firstDay,
      };
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/getLogList",
        data: params,
        success: function (res) {
          _this.dialogVisible = true;
          _this.fileList = res.data.data.data.fileInfos || [];
        },
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //加载数据
    initData: function () {
      let _this = this;
      //
      let sendUrl = "/cabinet/cabinet/" + _this.$route.query.id + "/filePage";
      // let sendUrl = "/cabinet/company/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = null;
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },

    //单项删除
    deleteItem: function (val) {},
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },

    //初始化图表
    initChart: function () {
      //处理数据
      let titleDaily = [];
      const _this = this;
      let tempList = []; //温度
      let voMax = 0;
      let voMin = 0;
      let tempMax = 0;
      let tempMin = 0;
      let voltageList = []; //电压
      if (this.dailyData.length != 0) {
        this.dailyData.map((key, index) => {
          let voltageArr = [];
          let tempArr = [];
          key.monomers.forEach((itme) => {
            tempArr.push(itme.temp);
            voltageArr.push(itme.voltage);
          });
          voMax =
            parseInt(Math.max.apply(null, voltageArr)) > voMax
              ? parseInt(Math.max.apply(null, voltageArr))
              : voMax;
          if (voMin == 0) {
            voMin = parseInt(Math.min.apply(null, voltageArr));
          } else {
            voMin =
              parseInt(Math.min.apply(null, voltageArr)) < voMin
                ? parseInt(Math.min.apply(null, voltageArr))
                : voMin;
          }
          tempMax =
            parseInt(Math.max.apply(null, tempArr)) > tempMax
              ? parseInt(Math.max.apply(null, tempArr))
              : tempMax;
          if (tempMin == 0) {
            tempMin = parseInt(Math.min.apply(null, tempArr));
          } else {
            tempMin =
              parseInt(Math.min.apply(null, tempArr)) < tempMin
                ? parseInt(Math.min.apply(null, tempArr))
                : tempMin;
          }
          const ylist = {
            name: "温度" + key.bmsNo,
            type: "line",
            data: tempArr,
            itemStyle: {
              normal: {
                color: _this.colorList[index > 3 ? 1 : index], //改变折线点的颜色
                lineStyle: {
                  color: _this.colorList[index > 3 ? 1 : index], //改变折线颜色
                },
              },
            },
          };
          tempList.push(ylist);
          const voltages = {
            name: "电压" + key.bmsNo,
            type: "line",
            data: voltageArr,
            itemStyle: {
              normal: {
                color: _this.colorList[index > 3 ? 1 : index], //改变折线点的颜色
                lineStyle: {
                  color: _this.colorList[index > 3 ? 1 : index], //改变折线颜色
                },
              },
            },
          };
          voltageList.push(voltages);
        });
        this.dailyData[0].monomers.map((item) => {
          titleDaily.push(item.monomerNo);
        });
      }
      const tempListName = tempList.map((r) => {
        return r.name;
      });
      const voltageListName = voltageList.map((r) => {
        return r.name;
      });

      //基于准备好的dom，初始化echarts实例
      let dailyChart = echarts.init(document.getElementById("dailyCharts"));
      let voltagesCharts = echarts.init(
        document.getElementById("voltagesCharts")
      );
      this.$nextTick(() => {
        dailyChart.resize();
        voltagesCharts.resize();
      });
      this.echartList.push(dailyChart);
      this.echartList.push(voltagesCharts);

      var optionDailyCustomer = {
        color: ["#3398DB"],
        title: {
          text: "电压折线",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: voltageListName,
          left: 100,
          icon: "rect",
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleDaily,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          splitArea: {
            show: true,
          },
          // max: 3400,
          // min: 3100,
          max: voMax + 50,
          min: voMin - 50,
          type: "value",
        },
        series: voltageList,
      };

      //绘制图表
      dailyChart.setOption(optionDailyCustomer);

      var voltagesChartsCustomer = {
        color: ["#3398DB"],
        title: {
          text: "温度折线",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: tempListName,
          left: 100,
          icon: "rect",
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleDaily,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          splitArea: {
            show: true,
          },
          max: tempMax + 2,
          min: tempMin - 2,
          type: "value",
        },
        series: tempList,
      };

      voltagesCharts.setOption(voltagesChartsCustomer);
    },
  },
};
</script>
<style scoped>
.mainbody,
.histroy_list {
  display: flex;
}
.font_w600 {
  font-weight: 600;
}
.el-card {
  margin: 10px;
}
.histroy_list {
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}
.histroy_list p {
  flex: 1;
  text-align: left;
}
.histroy_list p:last-child {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/Cell.vue